import { translate } from "@/utils/utils";
import { RootState } from "..";
import { GenParams } from "./GenParams";

export const buildTextToImageParam = async (state: RootState): Promise<GenParams> => {
  const design = state.mode.design;
  let refStructure: string | null = "";
  let refStructureType: string | null = "";
  let control_mode: string | null = "";
  let refSyle: string | null = "";
  let style: string | null = "";
  let refStyleWeight: number = 1;
  let refStructureWeight: number = 1;
  if (design.refstructure && design.refstructure.length > 0) {
    refStructure = design.refstructure[0].url;
    control_mode  =design.refstructure[0].control_mode;
    refStructureWeight = design.refstructure[0].weight;
    refStructureType = design.refstructure[0].refStructureType;
  }

  if (design.refstyle && design.refstyle.length > 0) {
    refSyle = design.refstyle[0].url;
    refStyleWeight = design.refstyle[0].weight;
  }

  if (design.style) {
    style = design.style.name;
  } else {
    style = "通用";
  }

  let bigModel: string | null = "";
  if (design.bigmodel) {
    bigModel = design.bigmodel.realname;
  }

  let smallModel: Record<string, number> = {};
  if (design.smallmodel && design.smallmodel.length > 0) {
    for (let index = 0; index < design.smallmodel.length; index++) {
      const element = design.smallmodel[index].loraname;
      smallModel[element] = design.smallmodel[index].weight;
    }
  }

  let vae: string = "";
  if (design.vae) {
    vae = design.vae;
  }

  let cfgscale: number = 7;
  if (design.cfgscale == 0) {
    cfgscale = 7;
  } else {
    cfgscale = design.cfgscale;
  }

  let typeVal = "TextToImage";
  if(design.type==="SmrToImage"){
    typeVal="SmrToImage"
  } 

  const graph: GenParams = {
    mode: design.mode,
    type: typeVal,
    prompt: design.prompt,
    negative_prompt: design.negativeprompt,
    generateType: translate(design.generatetype),
    n_iter: design.n_iter,
    width: design.width,
    height: design.height,
    style: style,
    refStructure: refStructure,
    refStructureWeight: refStructureWeight,
    refStyle: refSyle,
    refStyleWeight: refStyleWeight,
    baseImage: "",
    maskImage: "",
    seed: design.seed,
    steps: design.steps,
    sd_model_checkpoint: bigModel,
    lora: smallModel,
    vae: vae,
    cfgscale: cfgscale,
    control_mode: control_mode,
    refStructureType: refStructureType
  };
  return graph;
};
